export default {
  newQuoteLimitExceeded: "New quote quantity limit exceeded",
};
